import axiosInstance from "../../setupAxios";
import { IFileSystem } from "../types/IFileSystem";
import { IStoragePath } from "../types/IStoragePath";

export class StorageService {
    public static getFilesystems(path: string, isRepertoireModule?: boolean): Promise<IFileSystem[]> {
        return new Promise<IFileSystem[]>((resolve, reject) => {
            axiosInstance.post(encodeURI(`Storage/FileSystems`), {path: path, IsRepertoireModule: isRepertoireModule})
                .then(res => {
                    resolve(res.data);
                });
        });
    }

    public static getBlobs(path: string): Promise<IStoragePath[]> {
        return new Promise<IStoragePath[]>((resolve, reject) => {
            axiosInstance.post(encodeURI(`Storage/Blobs`), {path: path})
                .then(res => {
                    resolve(res.data);
                });
        });
    }

    public static updateMetadata(storagePaths: IStoragePath[]): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            axiosInstance.post(encodeURI(`Storage/Metadata`), storagePaths)
                .then(res => {
                    resolve(res.data);
                });
        });
    }

    public static downloadFile(path: string, isRepertoireModule?: boolean, optionalFileName?: string): Promise<string> {
        return new Promise<string>((resolve) => {
            const encodedPath = encodeURIComponent(path);
            const uri: string = `Storage/Download?filePath=${encodedPath}&isRepertoireModule=${isRepertoireModule ? true : false}&optionalFileName=${optionalFileName}`
            axiosInstance.get(encodeURI(uri))
                .then(res => {
                    if (res && res.status === 200)
                        resolve(res.data);
                    else
                        resolve(null);
                });
        });
    }

    public static async getUploadUri(path: string, isRepertoireModule?: boolean): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const encodedPath = encodeURIComponent(path);
            const uri: string = `Storage/Upload?filePath=${encodedPath}&isRepertoireModule=${isRepertoireModule ? true : false}`
            axiosInstance.get(encodeURI(uri))
                .then(res => {
                    if (res && res.status === 200)
                        resolve(res.data);
                    else {
                        reject(res.request.response);
                    }

                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        reject(error.response.data);
                    } else {
                        reject(error?.toString() ?? "Unknown error");
                    }
                });
        });
    }

    public static uploadFile(uri: string, file: any, currentUserNameNumber?: string, format?: string, originalFileName?: string): Promise<boolean> {
        const headers: Record<string, string> = {
            'x-ms-blob-type': 'BlockBlob',
        };

        if (currentUserNameNumber) {
            headers['x-ms-meta-ipnamenumber'] = currentUserNameNumber;
        }

        if (format) {
            headers['x-ms-meta-format'] = format;
        }

        if (originalFileName) {
            headers['x-ms-meta-originalfilename'] = originalFileName;
        }
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance.put(uri, file, { headers })
                .then(res => {
                    if (res && res.status === 201)
                        resolve(true);
                    else
                        reject(res);
                })
                .catch(error => {
                    reject(false);
                });
        });
    }
}